import { Component } from '@angular/core';
import { ProgressFacadeService } from '../../services/progress.facade.service';

@Component({
  selector: 'dragonfly-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss'],
  standalone: false,
})
export class ProgressBarComponent {
  constructor(public progress: ProgressFacadeService) {}
}
